import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../ui/cn.js';
import { FaClipboardList, FaChartBar, FaHome } from "react-icons/fa";
import { useEmbeddedNavigation } from '../hooks/useEmbeddedMode.js';

function NavItem({ to, label, icon: Icon, active }) {
  const { toEmbeddedPath } = useEmbeddedNavigation();

  return (
    <Link
      to={toEmbeddedPath(to)}
      className={cn(
        'group relative flex flex-col items-center justify-center gap-1 p-2 rounded-2xl transition-all duration-200',
        active
          ? 'text-ptcm-primary dark:text-blue-400'
          : 'text-ptcm-muted dark:text-gray-400 hover:text-ptcm-ink dark:hover:text-gray-200 hover:bg-white/70 dark:hover:bg-gray-800/50'
      )}
      aria-current={active ? 'page' : undefined}
    >
      {active && (
        <span className="absolute inset-0 bg-white dark:bg-blue-900/20 rounded-2xl -z-10 animate-in fade-in zoom-in-95 duration-200 shadow-ptcm-float" />
      )}
      <div className={cn('h-6 w-6 transition-transform group-active:scale-90', active ? 'scale-110' : '')}>
        <Icon
          strokeWidth={active ? 2.5 : 2}
          className="w-full h-full"
        />
      </div>
      <span className={cn('text-[10px] font-semibold transition-all', active ? 'opacity-100' : 'opacity-70 group-hover:opacity-100')}>
        {label}
      </span>
    </Link>
  );
}

export default function BottomNav() {
  const location = useLocation();
  const path = location.pathname;

  const isActive = (to) => {
    // ... logic remains same ...
    if (to === '/') return path === '/' || path.startsWith('/home');
    if (to === '/questionnaire') return path.startsWith('/questionnaire');
    if (to === '/results') return path.startsWith('/results');
    return path === to;
  };

  return (
    <div
      className={cn(
        'fixed left-0 right-0 z-50',
        'bg-ptcm-bg/90 dark:bg-gray-950/90 backdrop-blur-xl',
        'border-t border-ptcm-border/70 dark:border-gray-800',
        'shadow-[0_-10px_30px_-18px_rgba(43,53,97,0.18)] dark:shadow-none'
      )}
      style={{
        bottom: 0,
        paddingBottom: 'env(safe-area-inset-bottom)',
        height: 'calc(var(--ptcm-bottom-nav-h) + env(safe-area-inset-bottom))'
      }}
    >
      <div
        className="mx-auto max-w-md h-[var(--ptcm-bottom-nav-h)] px-6 grid grid-cols-3 gap-2 items-center justify-items-stretch"
      >
        <NavItem
          to="/"
          label="Accueil"
          active={isActive('/')}
          icon={FaHome}
        />
        <NavItem
          to="/questionnaire"
          label="Questionnaire"
          active={isActive('/questionnaire')}
          icon={FaClipboardList}
        />
        <NavItem
          to="/results"
          label="Stats"
          active={isActive('/results')}
          icon={FaChartBar}
        />
      </div>
    </div>
  );
}

